import { digests } from '@/mocks/homeContent';

export default function DigestTimeline() {
  return (
    <section id="digest" className="bg-foreground-900">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-12 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-accent-400">
              <span className="h-px w-8 bg-accent-400"></span> Annual Review
            </span>
            <h2 className="mt-3 font-display text-3xl font-black text-background-50 md:text-4xl">
              大盘点 <span className="text-accent-400">·</span> 按月归档
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-background-50/70">
            时间是最好的索引。把每个月、每个阶段的重要时刻按时序归档，让旧瓜也能顺着时间线找回来。
          </p>
        </div>

        <div className="relative">
          {/* vertical line (desktop) */}
          <span className="absolute left-[68px] top-2 bottom-2 hidden w-px bg-background-50/10 md:left-[70px] md:block"></span>

          <div className="flex flex-col gap-6 md:gap-8">
            {digests.map((d) => (
              <article
                key={d.date}
                className="group grid gap-4 md:grid-cols-[140px_1fr] md:gap-8"
              >
                {/* time marker */}
                <div className="relative flex items-start gap-3 pl-0 md:pl-0 md:pt-2">
                  <span className="relative z-10 mt-1 hidden h-3 w-3 rounded-full border-2 border-foreground-900 bg-accent-400 md:block"></span>
                  <div className="md:pl-4">
                    <span className="font-display text-xl font-black tabular text-background-50 md:text-2xl">{d.date}</span>
                    <span className="mt-1 flex w-fit rounded-full bg-background-50/10 px-2 py-0.5 text-[11px] font-medium text-accent-300 whitespace-nowrap">
                      {d.phase}
                    </span>
                  </div>
                </div>

                {/* card */}
                <div className="flex flex-col overflow-hidden rounded-lg border border-background-50/10 bg-foreground-800/60 sm:flex-row">
                  <div className="relative h-40 shrink-0 overflow-hidden sm:h-auto sm:w-44">
                    <img
                      src={d.image}
                      alt={d.title}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent to-foreground-900/40 sm:bg-gradient-to-r"></div>
                  </div>
                  <div className="flex flex-1 flex-col justify-center p-5 md:p-6">
                    <h3 className="font-display text-lg font-bold leading-snug text-background-50 md:text-xl">
                      {d.title}
                    </h3>
                    <p className="mt-2 line-clamp-3 text-[13px] leading-relaxed text-background-50/70">{d.summary}</p>
                    <span className="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-accent-400 transition-colors hover:text-accent-300 cursor-pointer">
                      查看完整盘点
                      <i className="ri-arrow-right-line text-sm"></i>
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}